module.exports = __webpack_public_path__ + "static/shine-5cbab4b8d11cf37c2ff6b2b284651e8c.svg";